export default __webpack_public_path__ + "static/media/AddNewTopic.54c30b1d.svg";